const data = [
  {
    id: 1,
    year: "1978年8月",
    description: "大阪市天王寺区玉造にて青果露天小売",
  },
  {
    id: 2,
    year: "1989年5月",
    description: "大阪市浪速区大国町に店舗を移転する",
  },
  {
    id: 3,
    year: "1996年2月",
    description: "大阪市阿倍野区美章園に店舗を移転する",
  },
  {
    id: 4,
    year: "1998年10月",
    description:
      "会社設立\n大阪市生野区田島（大阪市東部中央卸市場前）に移転\n株式会社大国フーズ設立し外食産業に配送納品の事業に特化する",
  },
  {
    id: 5,
    year: "2002年9月",
    description: "高齢者福祉施設などの総合食品納品を開始",
  },
  {
    id: 6,
    year: "2006年",
    description: "新館増設",
  },
  {
    id: 7,
    year: "2007年6月",
    description: "直営ショップ「とまと家族」を開店",
  },
  {
    id: 8,
    year: "2008年4月",
    description: "きのこ専門卸の協栄産業M＆A",
  },
  {
    id: 9,
    year: "2008年7月",
    description: "協栄産業を天王寺より大国フーズ本社内に移転",
  },
  {
    id: 10,
    year: "2009年3月",
    description: "大国ファーム　設立",
  },
  {
    id: 11,
    year: "2009年6月",
    description: "とまと家族　谷町町　開店\n惣菜製造の株式会社　大つるをM＆A",
  },
  {
    id: 12,
    year: "2010年4月",
    description: "大国ファーム　佐備:龍泉に7棟のハウス建築",
  },
  {
    id: 13,
    year: "2010年8月",
    description: "鹿児島県伊佐工場取得",
  },
  {
    id: 14,
    year: "2010年9月",
    description: "フレッシュ大国木津店　開店",
  },
  {
    id: 15,
    year: "2011年12月",
    description: "大国ファーム富田林　苺ハウス　完成",
  },
  {
    id: 16,
    year: "2012年3月",
    description: "大国ファーム　鹿児島県伊佐市と立地協定",
  },
  {
    id: 17,
    year: "2012年6月",
    description: "大国ファーム　6次産業化認定",
  },
  {
    id: 18,
    year: "2012年12月",
    description: "鹿児島県伊佐市とまとハウス建設",
  },
  {
    id: 19,
    year: "2013年1月",
    description: "広島県庄原市にて夏苺生産体制",
  },
  {
    id: 20,
    year: "2013年2月",
    description: "鹿児島県伊佐市苺ハウス建設",
  },
  {
    id: 21,
    year: "2013年7月",
    description: "鹿児島県伊佐市に「夢さくら館」オープン",
  },
  {
    id: 22,
    year: "2016年6月",
    description: "ベジリード設立　社長　澤井　厚二",
  },
  {
    id: 23,
    year: "2016年10月",
    description:
      "代表取締役社長　津田　保弘　会長職に就任\n専務　津田美津枝　代表取締役社長に就任",
  },
  {
    id: 24,
    year: "2020年4月",
    description: "澤井 厚二　代表取締役社長に就任",
  },
];
export default data;
